/**
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel/preconnect
 */
export function preconnectLinks(links: Array<string | null | undefined>) {
  const uniqueOrigins = Array.from(
    new Set(links.filter(Boolean).map((link) => new URL(link ?? '').origin))
  );
  return uniqueOrigins.map((origin) => ({
    href: origin,
    rel: 'preconnect',
    tagName: 'link',
  }));
}
